"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mkSmartRegistry = void 0;
const __1 = require("..");
function mkSmartRegistry() {
    const registrar = {};
    return {
        values() {
            return Object.values(registrar);
        },
        register(...args) {
            const [key] = args;
            return (ctor) => {
                registrar[key] = new ctor(...args);
            };
        },
        has(key) {
            return (0, __1.hasValue)(registrar, key);
        },
        get(key) {
            return (0, __1.getValueOrThrow)(registrar, key, `Expected key (${key}) to have a handler.`);
        },
        bind(key) {
            return () => (0, __1.getValueOrThrow)(registrar, key, `Expected key (${key}) to have a handler.`);
        }
    };
}
exports.mkSmartRegistry = mkSmartRegistry;
